import styles from "./Inicio.module.css";
function Inicio() {
  return (
    <div className={styles.container}>
      <h2 id="inicio">Sejam todos(as) bem-vindos(as)</h2>
      <h3>
        [...] No jogo existe alguma coisa "em jogo" que transcende as
        necessidades imediatas da vida e confere um sentido à ação. Todo jogo
        significa alguma coisa (Huizinga, 2001, p. 4).
      </h3>

      <p>
        Referência: Huizunga, Johan, 1872-1945. Homo ludens: o jogo como
        elemento da cultura / Johan Huizunga; tradução João Paulo Monteiro,
        revisão de tradução Newton Cunha. -- 9. ed. rev. e atual. -- São Paulo :
        Perspectiva, 2019. -- (Coleção Estudos; 4 / coordenação J. Guinsburg).
      </p>
    </div>
  );
}
export default Inicio;
